<template>
	<div class="col">
		<el-form :model="{list}" ref="ruleForm" v-loading.fullscreen.lock="loading">
			<el-form-item v-for="(item, i) in list" :key="i" :prop="`list[${i}].description`" :rules="{required:true, message:'圖片說明', trigger:'blur'}">
				<div class="row" align-y="center" gutter="10">
					<el-checkbox v-model="list[i].is_cover" :disabled="isCheckboxDisable(i)">設為封面</el-checkbox>
					<div class="thumb" :style="`background-image:url(${list[i].url})`"></div>
					<el-input v-model="list[i].description" type="textarea" :autosize="{minRows:2}" placeholder="請簡短說明這張照片"></el-input>
					<el-button @click="handleRemove(i)" icon="el-icon-minus" type="info" circle size="mini"></el-button>
				</div>
			</el-form-item>
		</el-form>
		<el-upload v-if="list.length < 5" class="upload-button" :action="postURL" accept="image/*" :show-file-list="false" :on-success="handleSuccess" :before-upload="beforeUpload">
			<i class="el-icon-circle-plus center"> 我要分享照片</i>
		</el-upload>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import API from "@/api";
export default {
	props: ["title"],
	data() {
		return {
			loading: false,
			list: []
		};
	},
	computed: {
		...mapState("story", ["editStoryData"]),
		postURL() {
			return `${API.baseURL}/api/upload/image/${this.editStoryData.account}`;
		},
		type() {
			switch (this.title) {
				case "感受":
					return "feeling";
				case "想像":
					return "imagine";
				case "實踐":
					return "implement";
				case "分享":
					return "share";
				default:
					return "feeling";
			}
		}
	},
	methods: {
		...mapMutations("story", ["updateEditStoryData"]),
		...mapActions("story", ["updateStory", "checkProgress"]),
		init() {
			this.list =
				(this.editStoryData.pictures && this.editStoryData.pictures[this.type] &&
					this.editStoryData.pictures[this.type].map(data => data)) ||
				[];
			console.log(`[${this.type}]:`, this.list);
		},
		isCheckboxDisable(i) {
			let checkedIndex = this.list.findIndex(item => item.is_cover);
			return checkedIndex >= 0 && checkedIndex != i;
		},
		beforeUpload(file) {
			this.loading = true;
		},
		handleSuccess(response, file, fileList) {
			this.list.push({
				is_cover: false,
				url: response.Location,
				description: ""
			});
			this.loading = false;
			if (this.list.length == 1) {
				this.list[0].is_cover = true;
			}
		},
		handleRemove(i) {
			this.list.splice(i, 1);
			if (this.list.length == 1) {
				this.list[0].is_cover = true;
			}
		},
		handleSave() {
			this.$refs.ruleForm.validate(valid => {
				if (valid) {
					let data = { pictures: {} };
					if (this.editStoryData.pictures) {
						data.pictures = this.editStoryData.pictures;
					}
					data.pictures[this.type] = this.list;
					this.updateEditStoryData(data);
				} else {
					throw "請檢查表格是否全部完成";
				}
			});
		}
	},
	created() {
		this.init();
	}
};
</script>

<style lang="scss" scoped>
.thumb {
	width: 100px;
	height: 60px;
	background-color: #ececec;
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
}
.upload-button {
	position: relative;
	width: 100%;
	height: 60px;

	i {
		position: absolute;
		top: 0;
		left: 0;
		border: 1px dashed #57aef1;
		border-radius: 6px;
		width: 100%;
		height: 100%;
		line-height: 1em;
		font-size: 16px;
		color: #57aef1;
	}
}
</style>